export default __webpack_public_path__ + "static/media/BrainBreak cards18.03fafc0a.png";